import FeatureImg from "public/cxPhoneSystem/featuresImg.png";
import Group1Img from "public/cxPhoneSystem/Group1.png";
import Group2Img from "public/cxPhoneSystem/Group2.png";
import Group3Img from "public/cxPhoneSystem/Group3.png";

export const FEATURE_CONSTANTS = {
  IMAGE: FeatureImg,
  FEATURES: [
    {
      title: "Secure, SIP-Based Infrastructure",
      description:
        "Encrypted SIP platform delivers secure, reliable, and private voice communication.",
      image: Group1Img,
    },
    {
      title: "Hybrid Integration with Existing Hardware",
      description:
        "Integrates existing PBX, phones, and infrastructure without major upgrades.",
      image: Group2Img,
    },
    {
      title: "Scalable VoIP for Growing Teams ",
      description: "Easily expand VoIP services as teams and needs grow.",
      image: Group3Img,
    },
  ],
};
